import { render } from "./LogedOut.vue?vue&type=template&id=49840d91&scoped=true"
import script from "./LogedOut.vue?vue&type=script&lang=js"
export * from "./LogedOut.vue?vue&type=script&lang=js"

import "./LogedOut.vue?vue&type=style&index=0&id=49840d91&scoped=true&lang=css"

import exportComponent from "/home/tek2991/Desktop/Works/Projects/NEW_EPMS/avant-teacher-production/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49840d91"]])

export default __exports__